import createQrCode from "qr.js";
export function createQrMatrix(payload) {
    const qr = createQrCode(payload);
    const moduleCount = qr.getModuleCount();
    return Array.from({ length: moduleCount }, (_, row) => Array.from({ length: moduleCount }, (_unused, column) => qr.isDark(row, column)));
}
//# sourceMappingURL=qr-code.js.map